module.exports = __webpack_public_path__ + "static/img/hzhb6.9fa3bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb6.png
// module id = Oug1
// module chunks = 0